// extracted by mini-css-extract-plugin
module.exports = {"link":"style_link__30zwW","underline":"style_underline__3uYmg"};